import React from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Header from 'components/Header/index';
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';
import Tour from '../components/Tour/index';
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from 'constants/ActionTypes';
import {isIOS, isMobile} from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import TopNav from 'components/TopNav';
import ColorOption from '../containers/Customizer/ColorOption';

class App extends React.Component {

  render() {
    const {match, drawerType, navigationStyle, horizontalNavPosition} = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add('ios-mobile-view-height')
    }
    else if (document.body.classList.contains('ios-mobile-view-height')) {
      document.body.classList.remove('ios-mobile-view-height')
    }
  
    return (
    
      <div className={`app-container ${drawerStyle}`}>
        {(this.props.authUser.iban === "" || this.props.authUser.bankName === "" || this.props.authUser.iban === null || this.props.authUser.bankName === null) ?   <Tour/> : null}
      

        <Sidebar/>
        <div className="app-main-container">
          <div
            className={`app-header ${navigationStyle === HORIZONTAL_NAVIGATION ? 'app-header-horizontal' : ''}`}>
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER) &&
            <TopNav styleName="app-top-header"/>}
            <Header/>
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) &&
            <TopNav/>}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                  <Route  path={`${match.url}/sample-page`}
                         component={asyncComponent(() => import('./routes/SamplePage'))}/>
                  <Route exact path={`${match.url}/`}
                         component={asyncComponent(() => import('./routes/SamplePage'))}/>
                  <Route path={`${match.url}/users`}
                         component={asyncComponent(() => import('./routes/Users'))}/>
                  <Route path={`${match.url}/institutions`}
                         component={asyncComponent(() => import('./routes/Institutions/InstitutionsTable'))}/>
                 <Route path={`${match.url}/profile`}
                         component={asyncComponent(() => import('./routes/Users/Profile'))}/>
                 <Route path={`${match.url}/taleSave`}
                         component={asyncComponent(() => import('./routes/Tale/SaveTalePage'))}/>
                  <Route path={`${match.url}/taleList`}
                         component={asyncComponent(() => import('./routes/Tale/ListTalePage'))}/>        
                 <Route path={`${match.url}/payments`}
                         component={asyncComponent(() => import('./routes/Payments/PaymentPage'))}/>        
                <Route path={`${match.url}/paymentsAdmin`}
                         component={asyncComponent(() => import('./routes/Payments/PaymentAdminPage'))}/>     
                <Route path={`${match.url}/taleListInbox`}
                         component={asyncComponent(() => import('./routes/Tale/ListTaleInboxPage'))}/>     
                <Route path={`${match.url}/writtenPubRequest`}
                         component={asyncComponent(() => import('./routes/WrittenPubRequest/WrittenPubRequestPage'))}/>     
                <Route path={`${match.url}/searchTale`}
                         component={asyncComponent(() => import('./routes/Tale/SearchTalePage'))}/>     
                <Route path={`${match.url}/editorList`}
                         component={asyncComponent(() => import('./routes/Admin/EditorListPage'))}/>     
                <Route path={`${match.url}/taleManagement`}
                         component={asyncComponent(() => import('./routes/Admin/TaleManagementPage'))}/>     
                          <Route path={`${match.url}/taleGroupList`}
                         component={asyncComponent(() => import('./routes/Editor/TaleGroupListPage'))}/>     
                 <Route path={`${match.url}/advisoryBoardTaleDataTable`}
                         component={asyncComponent(() => import('./routes/Tale/AdvisoryBoardListTalePage'))}/>    
                  <Route path={`${match.url}/announcement`}
                         component={asyncComponent(() => import('./routes/Editor/AnnouncementPage'))}/>   
                          <Route path={`${match.url}/myPastReviews`}
                         component={asyncComponent(() => import('./routes/Tale/MyPastReviewsTalePage'))}/>   
  <Route path={`${match.url}/statistics`}
                         component={asyncComponent(() => import('./routes/Editor/StatisticsPage'))}/>   
                            <Route path={`${match.url}/complatedTalePage`}
                         component={asyncComponent(() => import('./routes/Tale/ComplatedTalePage'))}/>     
                     <Route path={`${match.url}/privateContentTalePage`}
                         component={asyncComponent(() => import('./routes/Tale/PrivateContentTalePage'))}/>   
                      <Route path={`${match.url}/publicTalePage`}
                         component={asyncComponent(() => import('./routes/Tale/PublicTaleListPage'))}/>   
                      <Route path={`${match.url}/approvedTalePage`}
                         component={asyncComponent(() => import('./routes/Tale/ApprovedTaleListPage'))}/>   
                      <Route path={`${match.url}/rejectedTalePage`}
                         component={asyncComponent(() => import('./routes/Tale/RejectedTaleListPage'))}/>   
                      <Route path={`${match.url}/withdrawnTalePage`}
                         component={asyncComponent(() => import('./routes/Tale/WithdrawnTaleListPage'))}/>   
                      <Route path={`${match.url}/noContractTalePage`}
                         component={asyncComponent(() => import('./routes/Tale/NoContractTaleListPage'))}/>   
                      <Route path={`${match.url}/rejectErrorTalePage`}
                         component={asyncComponent(() => import('./routes/Tale/RejectErrorTaleListPage'))}/>   
                      <Route path={`${match.url}/correctionRequestedTalePage`}
                         component={asyncComponent(() => import('./routes/Tale/CorrectionRequestedTaleListPage'))}/>   
                      <Route path={`${match.url}/otherTalesTalePage`}
                         component={asyncComponent(() => import('./routes/Tale/OtherTalesListPage'))}/>   
                                      
                <Route path={`${match.url}/reviewTalePage`}
                         component={asyncComponent(() => import('./routes/Tale/ReviewTalePage'))}/>    
                <Route path={`${match.url}/appSettings`}
                         component={asyncComponent(() => import('./routes/AppSettings/List'))}/>
                <Route path={`${match.url}/appSettingsNew`}
                         component={asyncComponent(() => import('./routes/AppSettingsNew/List'))}/>
                <Route path={`${match.url}/course`}
                         component={asyncComponent(() => import('./routes/Course/NewCourse'))}/>
                <Route path={`${match.url}/courseList`}
                         component={asyncComponent(() => import('./routes/Course/List'))}/>
                <Route path={`${match.url}/courseApplication`}
                         component={asyncComponent(() => import('./routes/Course/CourseApplication'))}/>
                <Route path={`${match.url}/myCourses`}
                         component={asyncComponent(() => import('./routes/Course/MyCourses'))}/>
                <Route path={`${match.url}/courseDetails/:id`}
                         component={asyncComponent(() => import('./routes/Course/CourseDetails'))}/>
                <Route path={`${match.url}/myCourse/:id`}
                         component={asyncComponent(() => import('./routes/Course/MyCourse'))}/>

                <Route path={`${match.url}/researchTaleList`}
                         component={asyncComponent(() => import('./routes/Research/TaleListListPage'))}/>
                <Route component={asyncComponent(() => import('components/Error404'))}/>
             
              </Switch>
            </div>
            <Footer/>
          </main>
        </div>
        <ColorOption/>
      </div>
    );
  }
}


const mapStateToProps = ({settings,auth}) => {
  const {drawerType, navigationStyle, horizontalNavPosition} = settings;
  const {authUser} = auth;
  return {drawerType, navigationStyle, horizontalNavPosition,authUser}
};
export default withRouter(connect(mapStateToProps)(App));